/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {dlsColor} from '../theme/theme';
import useThemeContext from '../theme/useThemeContext';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Custom Import Icon component.
 */
export const ImportIcon = (props: IconProps) => {
  const {isCurrent: isCurrentTheme} = useThemeContext();
  const {
    color = dlsColor('aaBlue'),
    size = 24
  } = props;
  const {iconSize, iconColor} = useIconDLS({color, size});
  const finalColor = (isCurrentTheme && iconColor === dlsColor('aaBlue')) ? dlsColor('darkestBlue') : iconColor;
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M12.0974 5C8.9021 5 7.02234 6.87976 5.89422 9.13546C3.45103 9.13546 0.855858 11.2408 1.00624 14.3988C1.15662 17.5568 4.2651 19.0355 5.89422 19.2861H19.2405C20.4937 19.1608 23 18.1583 23 15.1507C23 12.1431 19.9924 10.8899 18.4886 10.6393C18.4886 8.00761 15.7065 5 12.0974 5Z'
        stroke={finalColor}
        strokeWidth='1.5' />
      <path d='M10.3992 15.9666V13.959C10.3992 13.6828 10.1754 13.459 9.89924 13.459H8.97469C8.52923 13.459 8.30615 12.9204 8.62113 12.6054L11.3615 9.86503C11.5568 9.66977 11.8734 9.66977 12.0686 9.86503L14.809 12.6054C15.124 12.9204 14.9009 13.459 14.4554 13.459H13.5309C13.2548 13.459 13.0309 13.6828 13.0309 13.959V15.9666C13.0309 16.2427 12.807 16.4666 12.5309 16.4666H10.8992C10.6231 16.4666 10.3992 16.2427 10.3992 15.9666Z'
        fill={finalColor} />
    </svg>
  );
};
